/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn, AliasType } from '../../registry/Component.type';
import { defaultValue } from './SignaturePad';
import { isNotEmpty } from '../../utils/isEmpty';
import { ItemType } from 'componentregistry/registry/ComponentRegistry';

const SignaturePadManager: ComponentManagerFn<'SignaturePad'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'SignaturePad'>(platform, 'SignaturePad'),
    type: 'SignaturePad',
    name: 'Signature Pad',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnSubmit'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      title: {
        label: 'Title',
        type: 'string',
      },
      open: {
        label: 'Open',
        type: 'boolean',
      },
      alias: {
        label: 'Data Store Alias',
        type: 'DataSourceAliasChooser',
        category: 'Data',
        allowedTypes: ['CloudDataStore', 'ReadOnlyDataStore', 'DataStore'],
        required: true,
      },
      viewAttribute: {
        label: 'View Attribute',
        type: 'ComboAttributeChooser',
        aliasType: 'LOV',
        category: 'Data',
        required: true,
        getAttributeDataTypes: () => ['Textarea'],
      },
      saveOnSubmit: {
        label: 'Save on Submit',
        type: 'boolean',
        category: 'Data',
        helpText:
          'Uncheck if you want to save the data store in a different action',
      },
    },
    isPropertyVisible(prop, itemData): boolean {
      if (prop === 'viewAttribute') return isNotEmpty(itemData.alias);
      return true;
    },
    getDisplayText: (item) => '',
    getDataSourceAliasProperty: (aliasType: AliasType) =>
      aliasType === 'LOV' ? { aliasProp: 'alias' } : undefined,
    isDataSourceAliasUsed: (item, alias) => item.props.alias === alias,
    icon: { iconName: 'file-signature' },
    description: `Signature pad is component that captures a person's handwritten signature on a canvas and saves it as an image.
To open the signature pad, use an Icon or Button anywhere on the page and set the 'Signature Pad ItemID' prop to the Item ID of this signature pad component.`,
    category: 'Data',
    canHaveChildren: () => false,
    noOverlay: true,
  };
};

export default SignaturePadManager;
